import { ContextType } from '../../../State/Game/IContext';
import BaseMenu from './BaseMenu';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import { StartAnimation } from '../../Animation/AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Game from '../../../Game';
import { GameActions } from '../../../State/Game/GameActions';
import LeaderboardHelper from '../LeaderboardHelper';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_CHALLENGE: string = 'main_container/challenge_button';
const LOSER_BAR: string = 'main_container/loser_bar';
const WINNER_BAR: string = 'main_container/winner_bar';

export default class ScoreBeatenMenuHandler extends BaseMenu {
    private levelNumber: number;
    private friendId: string;

    constructor(uiSystem: BaseUISystem) {
        super('scoreBeatenMenu', uiSystem);
    }

    protected onShow(params: any): void {
        // Store parameters.
        this.levelNumber = params.levelNumber;
        this.friendId = params.friendId;

        // Restore initial positions.
        const loserBar = this.element.find(LOSER_BAR);
        const winnerBar = this.element.find(WINNER_BAR);

        loserBar.getComponent(ElementComponent).anchorTopLeft.y = 0.36;
        loserBar.getComponent(ElementComponent).anchorBottomRight.y = 0.36;
        winnerBar.getComponent(ElementComponent).anchorTopLeft.y = 0.6;
        winnerBar.getComponent(ElementComponent).anchorBottomRight.y = 0.6;

        LeaderboardHelper.loadBeatenScore(
            loserBar,
            winnerBar,
            params.levelNumber,
            params.friendId
        );
    }

    protected onShown(): void {
        StartAnimation(this.element, 'ScoreBeaten', {
            scene: this.system.scene,
            loser: this.element.find(LOSER_BAR),
            winner: this.element.find(WINNER_BAR),
        });
    }

    protected onCreate(): void {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        // Button challenge.
        const btnChallenge = this.element.find(BTN_CHALLENGE);
        btnChallenge.on(GameObjectEvent.SELECTED, () => {
            Game.state.dispatch(
                GameActions.setContext(ContextType.SHARE_BEAT_HIGHSCORE_LEVEL, {
                    levelNumber: this.levelNumber,
                    friendId: this.friendId,
                })
            );
        });
        applyBounceButtonAnimation(btnChallenge, AUDIO_UI_BUTTON_DEFAULT);
    }
}
